import React from "react";
import { getPlatform, getCreatorProfileUrl } from "../../utils/platforms";

export function SocialLink({ platform, platformId, displayText, className = "" }) {
  const url = getCreatorProfileUrl(platform, platformId);
  const platformConfig = getPlatform(platform);
  const label = displayText ?? (platformId && !platformId.startsWith("http") ? `@${platformId.replace(/^@/, "")}` : platformId);
  const icon = platformConfig?.icon;

  if (!url) {
    return (
      <span className={`inline-flex items-center gap-1.5 text-theme-text ${className}`}>
        {icon && <span className="w-4 h-4 shrink-0 opacity-80">{icon}</span>}
        <span>{label}</span>
      </span>
    );
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-1.5 text-theme-primary hover:underline ${className}`}
      style={platformConfig?.color ? { color: platformConfig.color } : undefined}
    >
      {icon && <span className="w-4 h-4 shrink-0 [&>svg]:w-4 [&>svg]:h-4">{icon}</span>}
      <span>{label}</span>
    </a>
  );
}
